/**
 *
 * 현재 사용하지 않음
 *
 * **/
import {Component, ViewEncapsulation, Input, OnChanges, SimpleChanges, OnDestroy, OnInit} from '@angular/core';
import {setCulture, Browser} from '@syncfusion/ej2-base';
import {
    ILoadedEventArgs,
    ChartTheme,
    SeriesBaseModel,
    IAxisLabelRenderEventArgs
} from '@syncfusion/ej2-angular-charts';
import {Subscription} from 'rxjs/Subscription';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {Router} from '@angular/router';

setCulture('ko');

/* ES6 버전 TEST
import { enableRipple } from '@syncfusion/ej2-base';
enableRipple(true);
import { Tooltip, Crosshair, DateTime, ILoadedEventArgs, ChartTheme } from '@syncfusion/ej2-charts';
import { Chart, LineSeries, Legend } from '@syncfusion/ej2-charts';
import { Browser } from '@syncfusion/ej2-base';
Chart.Inject(LineSeries, DateTime, Tooltip, Crosshair, Legend);
*/

@Component({
    selector: 'syncfusion-chart-component',
    templateUrl: 'chart.component.html',
    styleUrls: ['../syncfusion.custom.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ChartComponent implements OnInit, OnChanges, OnDestroy {
    @Input() public chartList: Array<any>;
    @Input() public chartTitle: string;
    @Input() public xAxisName: string;
    @Input() public yAxisName: string;
    @Input() public intervalType: string;

    private subscription: Subscription;

    public width: string = Browser.isDevice ? '100%' : '100%';
    public marker: Object = { visible: true };
    public tooltip: Object = { enable: true, shared: true };
    public crosshair: Object = { enable: true, lineType: 'Vertical' };

    //Initializing Primary X Axis
    public primaryXAxis = {
        // minimum: new Date(2000, 1, 1),
        // maximum: new Date(2006, 2, 11),
        valueType: 'DateTime',
        intervalType: 'Days',  // Auto, Years, Months, Days, Hours, Minutes, Seconds
        // skeleton: 'y', // y, M, d, yMd, yM, Md
        lineStyle: { width: 0 },
        majorGridLines: { width: 0 },
        edgeLabelPlacement: 'Shift'
    };

    //Initializing Primary Y Axis
    public primaryYAxis = {
        title: '',
        // labelFormat: '{value}M',
        majorTickLines: { width: 0 },
        // minimum: 10,
        // maximum: 80,
        lineStyle: { width: 0 },
        labelFormat: 'n1'
    };

    public chartArea: Object = {
        border: {
            width: 0
        }
    };

    constructor(private translate: TranslateService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.setLocale();

        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.primaryYAxis.title = (this.yAxisName === 'MK.01468' || this.yAxisName === 'MK.01469') ? `${this.translate.instant(this.yAxisName)} (${this.translate.instant('MK.00993')})` : this.translate.instant(this.yAxisName);
            this.setLocale();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.primaryYAxis.title = (this.yAxisName === 'MK.01468' || this.yAxisName === 'MK.01469') ? `${this.translate.instant(this.yAxisName)} (${this.translate.instant('MK.00993')})` : this.translate.instant(this.yAxisName);
        this.primaryXAxis.intervalType = this.intervalType;
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    tooltipOverlap() {
      const wontTooltip = document.querySelectorAll('.ng-tooltip')[0];
      return wontTooltip.parentNode.removeChild(wontTooltip);
    }

    setLocale() {
        switch (this.translate.currentLang) {
            case 'ko':
                setCulture('ko');
                break;
            case 'en':
                setCulture('en-US');
                break;
            case 'zh':
                setCulture('zh');
                break;
            case 'ja':
                setCulture('ja');
                break;
        }
    }

    public load(args: ILoadedEventArgs): void {
        let selectedTheme: string = location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Bootstrap';
        args.chart.theme = <ChartTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, 'Dark');
    };

    public axisLabelRender(args: IAxisLabelRenderEventArgs): void {
        if (!isNaN(Number(args.text))) {
            args.text = String(Number(args.text));
        }
    };

    /* ES6 버전 TEST
    series = [];

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.chartList.length > 0 ) {
            this.rederChart();
        }
    }

    ngOnDestroy(): void {
    }

    rederChart() {
        const series = [];
        this.chartList.forEach(item => {
            const seriesObj = {
                type: 'Line',
                dataSource: [],
                name: '',
                xName: 'x',
                yName: 'y',
                width: 2,
                marker: { visible: true }
            };
            seriesObj.dataSource = item.dataSource;
            seriesObj.name = item.rsrcNm;
            series.push(seriesObj);
        });
        this.series = series;

        const chart: Chart = new Chart({
            //Initializing Primary X Axis
            primaryXAxis: {
                // minimum: new Date(2000, 1, 1),
                // maximum: new Date(2006, 2, 11),
                valueType: 'DateTime',
                intervalType: 'Days',  // Auto, Years, Months, Days, Hours, Minutes, Seconds
                // skeleton: 'y', // y, M, d, yMd, yM, Md
                lineStyle: { width: 0 },
                majorGridLines: { width: 0 },
                edgeLabelPlacement: 'Shift'
            },
            //Initializing Primary Y Axis
            primaryYAxis: {
                title: '',
                // labelFormat: '{value}M',
                majorTickLines: { width: 0 },
                // minimum: 10,
                // maximum: 80,
                lineStyle: { width: 0 },
            },
            chartArea: {
                border: {
                    width: 0
                }
            },
            //Initializing Chart Series
            series: this.series,
            //Initializing User Interaction Tooltip and Crosshair
            tooltip: { enable: true, shared: true },
            crosshair: { enable: true, lineType: 'Vertical' },
            //Initializing Chart title
            title: this.chartTitle,
            load: (args: ILoadedEventArgs) => {
                let selectedTheme: string = location.hash.split('/')[1];
                selectedTheme = selectedTheme ? selectedTheme : 'Bootstrap';
                args.chart.theme = <ChartTheme>(selectedTheme.charAt(0).toUpperCase() +
                    selectedTheme.slice(1)).replace(/-dark/i, 'Dark');
                args.chart.width = Browser.isDevice ? '100%' : '60%';
            }
        });

        chart.appendTo('#container');
    }
    */
}



// WEBPACK FOOTER //
// ./src/app/components/syncfusion/chart/chart.component.ts